import axios from "axios";

export const sendMessage = (data) => {
    return axios
      .post(`${process.env.REACT_APP_BASE_URL}/message/send-message`, data)
      .then((response) => response.data)
      .catch((e) => Promise.resolve(e));
  };